import type { SyncHasMany } from "@ember-data/model";
import Model, { hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";

export default class PriorityBioExamModel extends Model {
  @hasMany("therapeutical-area", { async: false, inverse: "priorityBioExams" })
  declare therapeuticalAreas: SyncHasMany<ModelRegistry["therapeutical-area"]>;

  get bioExamObservation() {
    return this.store.peekRecord("loinc", this.id);
  }
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "priority-bio-exam": PriorityBioExamModel;
  }
}
